module.exports = __webpack_public_path__ + "img/logo.983f082b.png";